import {
  cellPaddingStyle,
  cssClass,
  elideTextStyle,
  messageWithOrWithoutCount,
  TypedBodyCellProps
} from '@tableau/data-catalog-shared';
import { TabStyles } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '../../../../gen-src/Localize';

const nameCountCellClass = cssClass('nameCountCell', elideTextStyle, cellPaddingStyle);
const disabledNameCountCellClass = cssClass('nameCountCell', elideTextStyle, cellPaddingStyle, {
  pointerEvents: 'none',
  opacity: 0.6
});
const plusMoreCountsClass = cssClass('plusMoreCounts', {
  fontSize: TabStyles.Typography.Sizing.Small,
  marginLeft: TabStyles.Spacing.DefaultSpace,
  color: TabStyles.Typography.Color.Disabled
});

export type NamesWithCountCellProps = {
  readonly names: ReadonlyArray<string>;
  readonly count: number;
  readonly maxShown: number;
  readonly disabled?: boolean;
};

export function NamesWithCountCell(props: NamesWithCountCellProps): JSX.Element {
  const names = props.names.slice(0, props.maxShown).join(', ');
  const plusMore = messageWithOrWithoutCount(
    props.count - props.maxShown,
    { withCount: Messages.PlusMore, withoutCount: () => '' }
  );
  return (
    <div className={props.disabled ? disabledNameCountCellClass : nameCountCellClass} title={names + ' ' + plusMore}>
      {names}
      {props.count > props.maxShown ?
        <span className={plusMoreCountsClass}>
          {plusMore}
        </span>
        : null
      }
    </div>
  );
}

export function createNamesWithCountCellFormatter<T>(
  getNamesFromRowData: (rowData: T) => string[],
  getCountFromRowData: (rowData: T) => number,
  maxShown = 3,
  getDisabledFromRowData?: (rowData: T) => boolean,
): React.Factory<TypedBodyCellProps<T>> {
  return (props: TypedBodyCellProps<T>) => (
    <NamesWithCountCell
      names={getNamesFromRowData(props.row.data)}
      count={getCountFromRowData(props.row.data)}
      disabled={getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false}
      maxShown={maxShown}
    />
  );
}
